import type { Extension } from '../../../web-client';

/**
 * Resolves the active entry point for an extension into both the resource key to load and its
 * resolved HTML entry for a multi-entry bundle.
 *
 * When an `entryPoint` (e.g. `config`/`edit`/`view`/`create`/`contextConfig`) is active, both the
 * resource and its resolvedResourceEntry are read from that sub-property — otherwise they come from
 * the top-level resource. Resolving them together prevents the top-level resource's HTML filename
 * from bleeding into a sub-entry-point's CDN URL. The resolved entry only affects a URL via
 * `appendResolvedResourceEntry`, which is itself gated by `forge-ui-multi-entry-resource`.
 */
export const getExtensionEntryPoint = (
	extension: Extension,
	entryPoint?: string,
): { resolvedResourceEntry: string | undefined; resource: string } => {
	const entryPointProperties = entryPoint ? extension.properties[entryPoint] : extension.properties;

	return {
		resolvedResourceEntry: entryPointProperties?.resolvedResourceEntry,
		// Fall back to the top-level resource when the sub-entry-point has no resource of its own.
		resource: entryPointProperties?.resource || extension.properties.resource,
	};
};
